<template>
  <VoiceCenter />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
